import { Box, Stack } from '@mui/material';

const ENTRIES = [
    { label: 'Finished', border: '2px solid #229A16', background: '#F1FCEA' },
    { label: 'In progress', border: '2px solid #2065D1', background: '#FFFFFF' },
    { label: 'Not started', border: '2px solid #CFD6DE', background: '#FFFFFF' },
    { label: 'Planned — not in the catalogue yet', border: '2px dashed #919EAB', background: '#F4F6F8' },
    { label: 'Above your belt', border: '2px solid #CFD6DE', background: '#FFFFFF', faded: true },
    { label: 'Choice — pick some of the alternatives', border: '2px solid #8E5CD9', background: '#F5F0FF' },
];

/** Explains the station frames, which say little on their own. */
export function RoadmapLegend() {
    return (
        <Stack role="list" aria-label="Station marks" direction="row" flexWrap="wrap" gap={ 3 } sx={ { fontSize: 12, color: '#4F5B67' } }>
            { ENTRIES.map((entry) => (
                <Stack key={ entry.label } role="listitem" direction="row" alignItems="center" spacing={ 1 }>
                    <Box aria-hidden="true" sx={ {
                        width: 18, height: 12, borderRadius: '4px', boxSizing: 'border-box',
                        border: entry.border, bgcolor: entry.background, opacity: entry.faded ? 0.4 : 1,
                    } }/>
                    <span>{ entry.label }</span>
                </Stack>
            )) }
        </Stack>
    );
}
